import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { CellTooltip } from '../../..';

type MobileCellProps = ComponentProps<'div'> & {
  label: string;
  value: string;
  tooltip?: string;
};

function MobileCell({ className, label, value, tooltip, ...props }: MobileCellProps) {
  const classes = {
    cell: twMerge('flex justify-between items-center gap-x-2', className),
    valueContainer: 'flex gap-2 items-center',
    label: 'paragraph-explanatory',
    value: 'paragraph-explanatory-strong',
  };
  return (
    <div className={classes.cell} {...props}>
      <p className={classes.label}>{label}</p>
      <div className={classes.valueContainer}>
        <p className={classes.value}>{value}</p>
        {tooltip ? <CellTooltip>{tooltip}</CellTooltip> : null}
      </div>
    </div>
  );
}

export { MobileCell };
